<ng-template #trainrunAndSectionEditorTabsViewTemplate>
  <div
    class="trainrun-dialog-container"
    sbbDialog
    (mouseup)="onMouseUp()"
    (mousemove)="onMouseMove($event)"
    (mousedown)="onMouseDown($event)"
  >
    <div
      data-testid="train-run-tab-group"
      class="trainrun-dialog-tab-group"
      (mouseup)="onMouseUp()"
      (mousemove)="onMouseMove($event)"
      (mousedown)="onMouseDown($event)"
    >
      <sbb-tab-group [selectedIndex]="data.type">
        <sbb-tab
          label="{{ selectedTrainrun.getCategoryShortName() }}{{ selectedTrainrun.getTitle() }}"
          id="trainrun-tab"
        >
          <sbb-trainrun-tab
            [trainrunDialogParameter]="trainrunDialogParameter"
            (trainrunDeleted)="closeDialog()"
          ></sbb-trainrun-tab>
        </sbb-tab>
        <sbb-tab id="trainrun-section-tab">
          <ng-template sbb-tab-label
            >{{ nextStopLeftNodeName }}
            <sbb-icon
              [svgIcon]="trainrunService.getSbbArrowForTrainrunSectionDirection()"
              aria-hidden="false"
            ></sbb-icon>
            {{ nextStopRightNodeName }}
          </ng-template>
          <sbb-trainrunsection-tab [trainrunDialogParameter]="data"></sbb-trainrunsection-tab>
        </sbb-tab>
        <sbb-tab
          [label]="'app.view.dialogs.trainrun-and-section-dialog.filterableLabels' | translate"
          id="trainrun-filterable-labels-tab"
        >
          <sbb-trainrun-filter-tab (trainrunDeleted)="closeDialog()"></sbb-trainrun-filter-tab>
        </sbb-tab>
        <sbb-tab id="trainrun-roundTrip-tab">
          <ng-template sbb-tab-label>
            <sbb-icon
              [svgIcon]="trainrunService.getSbbArrowForTrainrunDirection()"
              aria-hidden="false"
            ></sbb-icon>
          </ng-template>
          <sbb-trainrun-roundtrip-tab
            (trainrunDeleted)="closeDialog()"
          ></sbb-trainrun-roundtrip-tab>
        </sbb-tab>
      </sbb-tab-group>
    </div>
  </div>

  <div
    class="dialog-drag-and-close-handle-area"
    (mouseup)="onMouseUp()"
    (mousemove)="onMouseMove($event)"
    (mousedown)="onMouseDown($event)"
  >
    <sbb-icon
      class="dialog-close-button-icon"
      svgIcon="cross-small"
      (click)="closeDialog()"
    ></sbb-icon>
    <sbb-icon class="dialog-drag-handle-icon" svgIcon="arrows-left-right-down-up-small"></sbb-icon>
  </div>
</ng-template>
